var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isMobile)?_c('div',[_c('IndexHeaderNav'),_c('router-view',{staticClass:"router"}),_c('Bottom')],1):_c('div',[_c('LayoutMobileHeader'),_c('router-view',{staticClass:"router"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }